/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, COMMON, API_CONSTANTS, SYNC_SERVICE } from '../../global/Constants';
import './krishak.css';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import Select from 'react-select';
import GpsCoordinates from '../common/GpsCoordinates';
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import { toast } from 'react-toastify';
import Utilities from '../../global/Utilities';
import AddNewImages from '../common/AddNewImages';
import { ActivityStatusType, CROP_GROUP } from '../../global/Enum';
import SyncServices from '../../providers/SyncServices';
import DataProvider from '../../providers/DataProvider';
import AuthService from '../../providers/AuthService';
import SyncLoader from '../common/loader/SyncLoader';

class AddSampleDistribution extends Component {

    constructor(props) {
        super(props);
        this.goBack = this.goBack.bind(this);
        this.state = {
            isLoading: false,
            opvResearch: '',
            remarks: '',
            activity: {},
            krishakInfo: {},
            quantityData: [],
            checkVarietyData: [],
            nearByRetailerData: [],
            sampleTypes: [],
            selectedQuantity: null,
            selectedCheckVariety: null,
            selectedNearByRetailers: [],
            activity_images: [],
            sampleType: null,
            S2SData: [
                { id: 1, name: COMMON.YES },
                { id: 0, name: COMMON.NO },
            ],
            isS2S: 0,
            latitude: null,
            longitude: null,
            deletedImages: [],
            isCheckVariety: true,
            //selectedFiles: null
        }
    }

    async componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            toast.configure();
            await DataProvider.getInstance().fetchMasterData();
            if (this.props.location.state) {

                let activity = this.props.location.state.activity;
                const krishakInfo = this.props.location.state.krishakInfo;
                if (krishakInfo) {
                    activity.krishak_id = krishakInfo?.krishak_id;
                    activity.temp_krishak_id = krishakInfo?.temp_krishak_id;
                    activity.temp_krishak_phone = krishakInfo?.phone;
                }
                if (activity) {
                    this.setState({
                        activity: activity,
                        krishakInfo: krishakInfo
                    }, () => {
                        //this.getRetailerByActivityId();
                        //this.getCheckVariety();

                        this.getQuantityGiven();
                        this.getCheckVariety(activity?.hybrid_id);
                        this.getNearbyRetailers();
                        this.getSampleTypes();

                        if (this.state.activity?.activity_status_id === ActivityStatusType.TO_RESUBMIT ||
                            this.state.activity?.activity_status_id === ActivityStatusType.PENDING_REVIEW) {
                            this.getActivityById(activity?.key);
                            this.getKrishakById(activity.krishak_id);
                        }
                    });
                }

            } else {
                this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    getQuantityGiven = () => {
        const data = DataProvider.getInstance().getQuantityGivens();
        if (data) {
            let quantitiesArray = [];
            data.forEach(element => {
                if (element.is_active === 1) {
                    let obj = {
                        value: element.quantity_given_id,
                        label: element.quantity_given_name + " " + element.weight_unit_name
                    }
                    quantitiesArray.push(obj);
                }
            });
            this.setState({
                quantityData: quantitiesArray,
            });
        }
    }

    getCheckVariety = (hybridId) => {
        const competitorHybrids = DataProvider.getInstance().getCompetitorHybrid(hybridId);
        if (competitorHybrids) {
            const checkVarietyArray = competitorHybrids?.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
            this.setState({
                checkVarietyData: checkVarietyArray,
            });
        }
    }


    getNearbyRetailers = () => {
        const { activity } = this.state;
        const crops = DataProvider.getInstance().getCrops();
        let crop = crops.find(item => item.crop_id === activity.crop_id);
        let is_vc = 1;
        if (crop.crop_group_id === CROP_GROUP.FIELD_CROPS) {
            is_vc = 0;
        } else {
            is_vc = 1;
        }

        const retailers = DataProvider.getInstance().getRetailers();
        if (retailers) {
            const retailerData = retailers.filter(item => {
                return (item.is_vc === is_vc);
            });

            let retailerDataArray = [];
            retailerData.forEach(element => {
                let obj = {
                    value: element.retailer_id,
                    label: element.retailer_name + " - " + element.phone
                }
                retailerDataArray.push(obj);
            });

            this.setState({
                nearByRetailerData: retailerDataArray
            })
        }
    }

    getSampleTypes = () => {
        const hideOptions = ["SBS", "Lucky Draw"];
        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_TYPE_OF_SAMPLE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data) {
                //Utilities.LogPrint("getSampleTypes:", data);
                // this.setState({
                //     sampleTypes: data
                // })

                //TODO As Per VC User Changes
                if (AuthService.isVcUser()) {
                    const newArray = data.filter(sampleType => {
                        return !hideOptions.find(option => { return (sampleType.type_of_sample_name == option); });
                    });
                    this.setState({
                        sampleTypes: newArray
                    });
                } else {
                    this.setState({
                        sampleTypes: data
                    });

                }
            }
        });
    }

    getActivityById = (activityId) => {
        // With Offline
        SyncServices.getActivityById("key", activityId).then(activity => {
            const data = activity?.data;
            if (data) {
                this.setState({
                    //activity: item,
                    //selectedQuantity: objQuantityGiven,
                    //selectedCheckVariety: objCheckVariety,
                    //selectedNearByRetailers: objNearByRetailer,
                    opvResearch: data?.research,
                    sampleType: Number(data.type_of_sample),
                    isS2S: data.is_s2s,
                    remarks: data.remark,
                    activity_images: data?.activity_images,
                    isLoading: false
                }, () => {
                    this.getNearbyRetailersById(data?.sample_distribution_near_retailer);
                    this.getQuantityGivenById(data?.quantity_given_id);
                    this.getCheckVarietyById(data?.check_variety_id);
                });
            }
        });

        //  With API
        // var params = JSON.stringify({
        //     activity_id: item.activity_id
        // });
        // try {
        //     ApiServices.getActivityById(params)
        //         .then(response => {
        //             var status = response.success
        //             if (status) {
        //                 Utilities.LogPrint("getActivityById", response.data);

        //                 let objQuantityGiven = response.data.sample_distribution.quantity_given
        //                 objQuantityGiven.value = objQuantityGiven.quantity_given_id
        //                 objQuantityGiven.label = objQuantityGiven.quantity_given_name
        //                 Utilities.LogPrint('objQuantityGiven', objQuantityGiven);

        //                 let objCheckVariety = response.data.sample_distribution.competitor_hybrid
        //                 objCheckVariety.value = objCheckVariety.competitor_hybrid_id
        //                 objCheckVariety.label = objCheckVariety.season_name
        //                 Utilities.LogPrint('objCheckVariety', objCheckVariety);

        //                 let objNearByRetailer = response.data.sample_distribution_near_retailer.map(({ retailer_id: value, retailer_shop_name: label, ...rest }) => ({ value, label, ...rest }));
        //                 Utilities.LogPrint('objNearByRetailer', objNearByRetailer);

        //                 let objImage = response.data.activity_images.map(({ image_url: value, ...rest }) => ({ value, ...rest }));
        //                 Utilities.LogPrint('objImage', objImage);

        //                 this.setState({
        //                     activity: item,
        //                     krishakInfo: response.data.krishak,
        //                     selectedQuantity: objQuantityGiven,
        //                     selectedCheckVariety: objCheckVariety,
        //                     selectedNearByRetailers: objNearByRetailer,
        //                     opvResearch: response.data.sample_distribution.research,
        //                     sampleType: Number(response.data.sample_distribution.type_of_sample),
        //                     isS2S: response.data.sample_distribution.is_s2s,
        //                     remarks: response.data.sample_distribution.remark,
        //                     images: objImage,
        //                     isLoading: false
        //                 });
        //             }
        //             else {
        //                 this.setState({ isLoading: false });
        //             }
        //         })
        //         .catch(error => {
        //             Utilities.LogPrint("getActivityById-catch", error);
        //         });
        // }
        // catch (error) {
        //     //this.props.loaderCallback(false);
        //     Utilities.LogPrint("getActivityById-error", error);
        // }
    }

    getQuantityGivenById = (quantityId) => {
        const { quantityData } = this.state;
        if (quantityData) {
            const quantityGiven = quantityData.find(item => item.value === quantityId);
            if (quantityGiven) {
                this.setState({ selectedQuantity: quantityGiven });
            }
        }
    }

    getCheckVarietyById = (checkVarietyId) => {
        const { checkVarietyData } = this.state;
        if (checkVarietyData) {
            const checkVariety = checkVarietyData.find(item => item.value === checkVarietyId);
            if (checkVariety) {
                this.setState({ selectedCheckVariety: checkVariety });
            }
        }
    }

    getNearbyRetailersById = (retailers) => {
        const { nearByRetailerData } = this.state;
        if (nearByRetailerData) {
            const selectedRetailers = nearByRetailerData.filter(item => {
                return retailers?.find(retailer => { return retailer.retailer_id === item.value });
            });
            if (selectedRetailers != null) {
                this.setState({ selectedNearByRetailers: selectedRetailers })
            }
        }
    }

    //DELETE IMAGE API CALL FOR INDIVIUDAL VISIT & SAMPLE DISTRIBUTION EDIT PART 
    deleteActivityImageApi = (item) => {
        var params = JSON.stringify({
            activity_image_id: item.activity_image_id,
        });
        try {
            ApiServices.deleteActivityImage(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        Utilities.LogPrint("deleteActivityImage", response.message);
                    }
                    else {
                        this.setState({ isLoading: false });
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("deleteActivityImage-catch", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("deleteActivityImage-error", error);
        }
    }

    getKrishakById = (krishak_id) => {
        SyncServices.findKrishakFromDatabase("krishak_id", String(krishak_id)).then(data => {
            if (data) {
                if (data.is_active === undefined || data.is_active === null || data.is_active === 1) {
                    const krishakInfo = data;
                    this.setState({
                        krishakInfo
                    });
                }
            }
        });
    }


    goBack = () => {
        this.props.history.goBack();
    }

    viewKrishakInfo = () => {
        const { krishakInfo } = this.state;
        Utilities.LogPrint("krishakInfo ==", krishakInfo);
        this.props.history.push({
            pathname: ALL_ROUTES.KRISHAK_INFO_ROUTE,
            state: { krishak_id: krishakInfo.krishak_id === 0 ? krishakInfo.temp_krishak_id : krishakInfo.krishak_id }
            //state: { krishak_id: this.state.krishakInfo.krishak_id }
        });
    }



    handleQuantityChange = selectedQuantity => {
        this.setState({ selectedQuantity });
    };

    handleCheckVarietyChange = selectedCheckVariety => {
        this.setState({ selectedCheckVariety });
    };

    handleNearbyRetailerChange = selectedNearByRetailers => {
        this.setState({ selectedNearByRetailers });
    };

    getCoordinates = (latLng) => {
        this.setState({
            latitude: latLng.latitude,
            longitude: latLng.longitude
        })
    }

    handleSampleType = (e) => {

        const sampleType = this.state.sampleTypes.find(item => item.type_of_sample_id === parseInt(e.target.value));

        this.setState({
            sampleType: e.target.value,
            isCheckVariety: sampleType?.is_check_variety === 0 ? false : true
        });
    }

    handleS2S = (e) => {
        this.setState({ isS2S: parseInt(e.target.value) });
    }

    handleAddImages = (images) => {
        Utilities.LogPrint("Images", images);
        this.setState({ activity_images: images });
    }

    handleDeleteImages = (deletedImage) => {
        var deletedImagesArray = this.state.deletedImages.slice();
        deletedImagesArray.push(deletedImage);
        this.setState({ deletedImages: deletedImagesArray }, () => {
            Utilities.LogPrint("Images Deleted", this.state.deletedImages);
        });
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    isSampleToSale(activity) {
        const sampleToSaleCrops = DataProvider.getInstance().getSampleToSaleCrop();
        if (sampleToSaleCrops.length > 0) {
            const isS2S = sampleToSaleCrops?.some(item => item.crop_id === activity.crop_id);
            if (isS2S) {
                this.editActivity();
            } else {
                toast.info("Crop is not available for sample to sale");
            }
        } else {
            toast.info("Crop is not available for sample to sale");
        }

        // this.setState({ isLoading: true });
        // var request = JSON.stringify({
        //     activity_id: activityId
        // });

        // try {
        //     ApiServices.isSampleToSale(request)
        //         .then(response => {
        //             Utilities.LogPrint("IS SAMPLE SALE: ---->", response);
        //             this.setState({ isLoading: false });
        //             if (response.success) {
        //                 //const data = response.data;
        //                 this.editActivity();
        //             } else {
        //                 toast.info(response.message);
        //                 Utilities.LogPrint("Status", response.message);
        //                 if (response.message !== undefined && response.message) {
        //                     this.setState({
        //                         errorMsg: response.message
        //                     });
        //                 }
        //             }
        //         }).catch(error => {
        //             this.setState({ isLoading: false, errorMsg: error });
        //         });
        // } catch (error) {
        //     this.setState({ isLoading: false, errorMsg: error });
        // }
    }

    editActivity() {
        //this.setState({ isLoading: true });
        const { activity, selectedQuantity, selectedCheckVariety, opvResearch, selectedNearByRetailers, sampleType, isS2S,
            latitude, longitude, remarks, activity_images, deletedImages } = this.state;

        const session = AuthService.getSession();
        const isTMLogin = session?.user.user_id === activity?.user_id ? true : false;
        const checkVariety = selectedCheckVariety !== null ? selectedCheckVariety?.value : 0;


        let selectedRetailers = [];
        selectedNearByRetailers.forEach(element => {
            let retailer = {
                retailer_id: element.value
            };
            selectedRetailers.push(retailer);
        });

        let dataObject = {
            key: activity?.key,
            activity_id: activity.activity_id,
            activity_type_id: activity?.activity_type_id,
            activity_status_id: isTMLogin ? ActivityStatusType.COMPLETED : ActivityStatusType.PENDING_REVIEW,
            krishak_id: activity?.krishak_id,
            temp_krishak_id: activity?.temp_krishak_id,
            temp_krishak_phone: activity.temp_krishak_phone,
            retailer_id: activity.retailer_id,
            quantity_given_id: selectedQuantity.value,
            check_variety_id: checkVariety,
            research: opvResearch,
            sample_distribution_near_retailer: selectedRetailers,
            type_of_sample: sampleType,
            is_s2s: isS2S,
            latitude: latitude,
            longitude: longitude,
            remark: remarks,
            activity_images: activity_images,
            deletedImages: deletedImages
        }
        SyncServices.editActivity(dataObject, "false");
        //this.goBack();

        // If User Online
        if (Utilities.isNetworkConnected() && activity.activity_id > 0 && activity.krishak_id > 0) {

            // For Images
            let activity_images_array = [];
            let activity_images = [];
            for (let i = 0; i < dataObject?.activity_images?.length; i++) {
                const objImage = dataObject?.activity_images[i];

                if (objImage.image_id === 0) {
                    let obj = {
                        temp_image_id: objImage.temp_image_id,
                        name: objImage.name
                    }
                    activity_images_array.push(obj);
                    activity_images.push(objImage.file);
                }
            }

            if (deletedImages.length > 0) {
                for (let i = 0; i < deletedImages?.length; i++) {
                    const objImage = deletedImages[i];
                    let obj = {
                        image_id: objImage.image_id,
                        isDeleted: objImage.isDeleted
                    }
                    activity_images_array.push(obj);
                }
            }

            const formData = new FormData();

            formData.append("activity_id", activity.activity_id);
            formData.append("retailer_id", activity.retailer_id);
            formData.append("krishak_id", activity?.krishak_id);
            formData.append("quantity_given_id", selectedQuantity.value);
            formData.append("check_variety_id", checkVariety);
            formData.append("type_of_sample", sampleType);
            formData.append("research", opvResearch);
            formData.append("is_s2s", isS2S);
            formData.append("latitude", latitude);
            formData.append("longitude", longitude);
            formData.append("sample_distribution_near_retailer", JSON.stringify(selectedRetailers));
            formData.append("remark", remarks);
            formData.append("activity_status_id", dataObject.activity_status_id);
            formData.append("activity_images_array", JSON.stringify(activity_images_array));

            if (activity_images.length > 0) {
                for (let i = 0; i < activity_images.length; i++) {
                    //const file = activity_images[i];
                    //const newName = new Date().getTime() + file.name;
                    formData.append("activity_image", activity_images[i]);
                }
            }
            this.setState({ isLoading: true });
            try {
                ApiServices.editActivity(formData)
                    .then(response => {
                        this.setState({ isLoading: false });
                        Utilities.LogPrint("API_DATA: ---->", response);
                        this.setState({ loading: false });
                        if (response.success) {
                            //toast.success(response.message);
                            const data = response.data;
                            if (data != null) {
                                const activity_images = data?.activity_images;
                                SyncServices.getActivityById("key", dataObject.key).then(activity => {
                                    let activityObj = activity;
                                    activityObj.is_synced = "true";
                                    activityObj.data.address = data?.address;
                                    activityObj.data.deletedImages = [];

                                    if (activity_images) {
                                        //let images = activityObj?.data?.images;
                                        activityObj?.data?.activity_images.forEach((element, index) => {
                                            if (element.image_id === 0) {
                                                const image = activity_images?.find(item => item.temp_image_id === element.temp_image_id);
                                                if (image) {
                                                    element.image_id = image.image_id;
                                                    element.image_url = image.image_url;
                                                    //element.byteArray = await Utilities.getImageBytesFromUrl(image.image_url);
                                                }
                                            }
                                        });
                                        SyncServices.editActivityWithServer(activityObj, "true");
                                        this.goBack();
                                    }
                                });
                            }
                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            } else {
                                toast.info(response.message);
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false });
            }
        } else {
            this.goBack();
        }

        // const formData = new FormData();
        // formData.append("activity_id", activity.activity_id);
        // formData.append("retailer_id", activity.retailer_id);
        // formData.append("krishak_id", krishakInfo.krishak_id);
        // formData.append("quantity_given_id", selectedQuantity.value);
        // formData.append("check_variety_id", selectedCheckVariety.value);
        // formData.append("type_of_sample", sampleType);
        // formData.append("research", opvResearch);
        // formData.append("is_s2s", isS2S);
        // formData.append("latitude", latitude);
        // formData.append("longitude", longitude);
        // formData.append("sample_distribution_near_retailer", JSON.stringify(selectedRetailers));
        // formData.append("remark", remarks);
        // formData.append("activity_status_id", 3);

        // for (var i = 0; i < images.length; i++) {
        //     formData.append("activity_image", images[i]);
        // }

        // try {
        //     ApiServices.editActivity(formData)
        //         .then(response => {
        //             //Utilities.LogPrint("API_DATA: ---->", response);
        //             this.setState({ isLoading: false });
        //             if (response.success) {
        //                 this.goBack();
        //             } else {
        //                 Utilities.LogPrint("Status", response.message);
        //                 if (response.message !== undefined && response.message) {
        //                     this.setState({
        //                         errorMsg: response.message
        //                     });
        //                 }
        //             }
        //         }).catch(error => {
        //             this.setState({ isLoading: false, errorMsg: error });
        //         });
        // } catch (error) {
        //     this.setState({ isLoading: false, errorMsg: error });
        // }

    }

    handleSaveButton = () => {
        const { activity, isS2S } = this.state;

        if (isS2S === 1) {
            this.isSampleToSale(activity);
        } else {
            this.editActivity();
        }
    }

    isFormValid() {
        const { selectedQuantity, selectedCheckVariety, sampleType, isS2S, activity_images, isCheckVariety, latitude, longitude } = this.state;
        return selectedQuantity === null || (isCheckVariety ? selectedCheckVariety === null : "") ||
            sampleType === null || isS2S === null || activity_images?.length === 0 || activity_images === undefined ||
            latitude === null || longitude === null;
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, activity, krishakInfo, quantityData, checkVarietyData, nearByRetailerData, selectedQuantity, selectedCheckVariety, selectedNearByRetailers,
            sampleTypes, sampleType, opvResearch, remarks, activity_images, isS2S, S2SData } = this.state;
        const { isSyncLoading, tableName } = this.state;

        const sampleLists = sampleTypes.map((item, i) => {
            if (sampleType === item.type_of_sample_id) {
                return (
                    <div className="radiobox-container" key={i}>
                        <input type="radio" name="radio2" checked value={item.type_of_sample_id} onChange={this.handleSampleType} />
                        <span className="checkmark">{item.type_of_sample_name}</span>
                    </div>
                )
            } else {
                return (
                    <div className="radiobox-container" key={i}>
                        <input type="radio" name="radio2" value={item.type_of_sample_id} onChange={this.handleSampleType} />
                        <span className="checkmark">{item.type_of_sample_name}</span>
                    </div>
                )
            }
        });

        const S2SLists = S2SData.map((item, i) => {
            return (
                <div className="radiobox-container" key={i}>
                    <input type="radio"
                        name="radio3"
                        checked={item.id === isS2S}
                        value={item.id}
                        onChange={this.handleS2S} />
                    <span className="checkmark">{item.name}</span>
                </div>
            )
        });

        let getKrishakPhoneNo = "+91 - " + krishakInfo?.phone;

        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />

                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <div className="activity-info-box brown-activity text-white mb-3">
                                <span>{activity.activity_tag}</span>
                                <h5>{activity.activity_type_name}</h5>
                                <span>{activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name}</span>
                            </div>
                        </div>
                    </div>

                    <div className="individual-visit-farmer">
                        {/* Input Farmer and Mobile Number */}
                        <div className="row">
                            <div className="col-12 col-md-5 col-lg-4">
                                <div className="form-group mb-md-0">
                                    <input type="text" className="form-control max-w-360" value={krishakInfo?.name} placeholder="Farmer Name" disabled />
                                </div>
                            </div>
                            <div className="col-12 col-md-5 col-lg-4">
                                <div className="form-group mb-md-0">
                                    <input type="text" className="form-control" value={getKrishakPhoneNo} placeholder="" disabled />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-5 col-lg-4">
                                <a className="d-flex align-items-center my-3" onClick={this.viewKrishakInfo}>
                                    {COMMON.VIEW_DETAILED_FARMER_INFORMATION} <i className="customic ic-info-black ml-auto"></i>
                                </a>
                            </div>
                        </div>

                        <div className="sample-distribution-activity-form">
                            <div className="row">
                                {/* Quantity Given */}
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label className="font-weight-medium">Quantity Given</label>
                                        <Select className="mb-3 max-w-360"
                                            value={selectedQuantity}
                                            onChange={this.handleQuantityChange}
                                            options={quantityData}
                                            placeholder="Select any one"
                                            isClearable={true}
                                        />
                                    </div>
                                </div>

                                {/* Check Variety */}
                                <div className="col-lg-4" >
                                    <div className="form-group">
                                        <label className="font-weight-medium">Check Variety</label>
                                        <Select className="mb-3 max-w-360"
                                            value={selectedCheckVariety}
                                            onChange={this.handleCheckVarietyChange}
                                            options={checkVarietyData}
                                            placeholder="Select any one"
                                            isClearable={true}
                                        />
                                    </div>
                                </div>

                                {/* OPV / Research */}
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label className="font-weight-medium">OPV / Research</label>
                                        <input type="text" className="form-control" placeholder="Type here"
                                            name="opvResearch" value={opvResearch} onChange={this.changeHandler} />
                                    </div>
                                </div>
                            </div>

                            {/* Nearby Retailers */}
                            <div className="form-group">
                                <label className="font-weight-medium mt-2">Nearby Retailers</label>
                                <Select className="mb-3 max-w-360"
                                    isMulti
                                    value={selectedNearByRetailers}
                                    options={nearByRetailerData}
                                    onChange={this.handleNearbyRetailerChange}
                                    placeholder="Select one or multiple"
                                />
                            </div>

                            {/* Type of Sample &  Are you going to do S2S */}
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="form-group mb-0">
                                        <label className="font-weight-medium mt-2">Type of Sample</label>
                                        <div className="d-flex flex-wrap radiobox-container-row">
                                            {sampleLists}
                                        </div>
                                    </div>
                                </div>

                                {!AuthService.isVcUser() ?
                                    <div className="col-lg-8">
                                        <div className="form-group mb-0">
                                            <label className="font-weight-medium mt-2">Are you going to do S2S?</label>
                                            <div className="d-flex flex-wrap radiobox-container-row">
                                                {S2SLists}
                                            </div>
                                        </div>
                                    </div> : null
                                }

                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="font-weight-medium mt-2">Remarks  <span className="font-weight-normal">(if any)</span></label>
                                        <textarea className="form-control" rows="6"
                                            name="remarks" value={remarks} onChange={this.changeHandler}></textarea>
                                    </div>
                                </div>
                            </div>

                            {/* Add Images */}
                            <div className="row">
                                <div className="col-lg-12">
                                    {/* <AddImages imagePaths={images} handleAddImages={this.handleAddImages} deleteActivityImageApi={this.deleteActivityImageApi} /> */}
                                    <AddNewImages
                                        handleAddImages={this.handleAddImages}
                                        images={activity_images}
                                        handleDeleteImages={this.handleDeleteImages}
                                    />
                                </div>
                            </div>
                        </div>



                        {/* GPS Co-ordinates */}
                        <GpsCoordinates getCoordinates={this.getCoordinates} />

                        <div className="row">
                            <div className="col-12 d-flex button-grp-bottom">
                                <button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn" onClick={this.goBack}>{COMMON.CANCEL}</button>
                                <button className="btn btn-primary w-50" onClick={this.handleSaveButton} disabled={this.isFormValid()}>{COMMON.SUBMIT}</button>
                            </div>
                        </div>

                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
            </div>
        )
    }
}
export default withRouter(AddSampleDistribution)